<button mat-button
        [ngClass]="[type, size]"
        [disabled]="disabled"
        (click)="onClickButton($event)"
>
  <ng-content></ng-content>
</button>
